export default __webpack_public_path__ + "b2ddcc1793e8a9ad3751a3208fce5a74.woff";